import suggest from './suggest';
import ages from './ages';
import roundTrip from './roundtrip/roundTrip';
import searchData from './searchData';
import getSearchData from './searchData/actions/getSearchData';
import resetSearchData from './searchData/actions/resetSearchData';

export const actions = {
  getSearchData,
  resetSearchData,
};

export const reducers = {
  ages,
  roundTrip,
  searchData,
  suggest,
};
